import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LabelText from '../../../IN/LabelText';

const FriendEmail = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { friendIndex, form_component, funnel_page_id } = props;
	form_component.label = t('電郵');

	const fv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;

	const [inputValue, setInputValue] = useState('');

	const registerField = () => {
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator) {
			var validators = {
				emailAddress: {
					message: t('電郵格式不正確')
				}
			};
			if (form_component.required) {
				validators.notEmpty = {
					message: t('此欄為必須填寫')
				};
			}
			
			const fieldName = `friend[${friendIndex}][email]`;
			
			try {
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: validators,
					selector: `input[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => {
		registerField();
	}, [fv, controller, form_component.required, t, friendIndex]);

	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t, friendIndex]);

	const onChange = (e) => {
		const value = e.target.value;
		setInputValue(value);
		
		if (controller === 'Shopcarts') {
			const fieldName = `friend[${friendIndex}][email]`;
			const domElement = document.querySelector(`input[name="${fieldName}"]`);
			if (domElement) {
				domElement.setAttribute('value', value);
				domElement.value = value;
			}
		}
	}

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<div>
				<p className="my-0 fw-bolder fs-5">{form_component.label}</p>
				<span className="text-gray-800 fs-7 d-block xt_area"></span>
			</div>
			<input
				type="text"
				name={`friend[${friendIndex}][email]`}
				placeholder={form_component.default_text_type === 'placeholder' ? form_component.default_text : ''}
				className="form-control-sm mb-3 form-control"
				id={`friend-${friendIndex}-email`}
				value={inputValue}
				onChange={onChange}
			/>
		</div>
	);
}

export default FriendEmail;
